// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2858":"dc3877d6","6946":"a6a95c18"}[chunkId] + ".chunk.css";
};